import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { A11yModule } from '@angular/cdk/a11y';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ts-ai-disclaimer-dialog',
  templateUrl: './ai-disclaimer-dialog.component.html',
  styleUrls: ['./ai-disclaimer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, MatButtonModule, A11yModule],
})
export class AiDisclaimerDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<AiDisclaimerDialogComponent>) {}

  accept(): void {
    this.dialogRef.close(true);
  }
}
